import GameDetailsCard from "./gameDetailsCard.molecule";

export default GameDetailsCard;
